import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
import React, { useState } from 'react';
import { BRAND_NAME } from '../../constants/Branding';
import { ContactList } from '../../constants/FooterView';
import WhatsupImg from '../../assets/images/footer/whatsapp.png';
import gamecura from '../../assets/images/common/gamecura.png';
import './Copyright.scss';
import webtitleImg from '../../assets/images/brand/title.png';
import { NavLink } from 'react-router-dom';
import { EXCH_SPORTS_MAP } from '../../constants/ExchangeEventTypes';
import { RootState } from '../../models/RootState';
import { connect } from 'react-redux';
import { EventType } from '../../models/EventType';
import SocialMedia from '../SocialMedia/SocialMedia';
import Above18 from "../../assets/images/icons/above18.svg";
import DisclaimerImg from "../../assets/images/icons/disclaimer.svg";
import { CloseOutlined } from '@material-ui/icons';
import { Button, Drawer } from '@material-ui/core';
import ResponsibleGaming from '../ResponsibleGaming/ResponsibleGaming';
import { DomainConfig } from '../../models/DomainConfig';

type FooterProps = {
  eventTypes: EventType[];
  allowedConfig: number;
  domainConfig: DomainConfig;
};

type responsibleGame = {
  launch: boolean;
  name: string;
};

const Copyright: React.FC<FooterProps> = (props) => {
  const { eventTypes, allowedConfig, domainConfig } = props;
  const [showDisclaimer, setShowDisclaimer] = useState<boolean>(true);
  const [responsibleDilalog, setresponsibleDialog] = useState<responsibleGame>({
    launch: false,
    name: null,
  });

  return (
    <div>
      {
        !domainConfig.payments ?
          <IonRow class="copyright-ctn">
            <IonCol sizeLg="4" sizeSm="12" sizeXs="12" className='mob-footer-logo-ctn'>
              <img className='footer-logo-web web-view' src={webtitleImg} />
              <img className='footer-logo-mob mob-view' src={webtitleImg} />
              <div className="b-text">PEAK GAMING SRL</div>
              <div>San Jose , Costa Rica </div>
              <div className="above-18-years">
                All above <img src={Above18} /> Years
              </div>
              <div className="contact-section">
                {ContactList[BRAND_NAME] ? (
                  <>
                    <IonImg className="image" src={WhatsupImg} />
                    {ContactList[BRAND_NAME]}
                  </>
                ) : (
                  ''
                )}
              </div>
            </IonCol>
            <IonCol sizeLg="5" sizeSm="12" sizeXs="12">
              <div className="footer-link-ctn">
                <div className="footer-title sport-algin">Sports</div>
                <div className="footer-link-div-ctn">
                  <IonRow>
                    {eventTypes.map((et, eId) =>
                      (allowedConfig & Number(EXCH_SPORTS_MAP[et.slug])) !== 0 ? (

                        <IonCol sizeLg="3" sizeSm="3" sizeXs="3">
                          <div className='footer-link-div'>
                            <NavLink className="footer-link" to={`/exchange_sports/${et.slug}`}>{et.name}</NavLink>
                          </div>
                        </IonCol>

                      ) : null)}
                  </IonRow>
                </div>
              </div>
            </IonCol>
            <IonCol sizeLg="3" sizeSm="12" sizeXs="12">
              <div className="footer-link-ctn">
                <div className="footer-social-title">Get connected with us on social networks:</div>
                <div className="footer-link-div-ctn">
                  <IonCol className="web-social-media-group">
                    <SocialMedia></SocialMedia>
                  </IonCol>
                </div>
              </div>
            </IonCol>
            {/* <IonCol sizeLg="2" sizeSm="4" sizeXs="4">
        <div className="footer-link-ctn">

          <div className="footer-title">About</div>
          <div className='footer-link-div'>
                  <div className="footer-link" to={`/`}>About Mazaa</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>B2B</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Licensing</NavLink>
                </div>
          </div>
        </IonCol> */}
            {/* <IonCol sizeLg="2" sizeSm="4" sizeXs="4">
        <div className="footer-link-ctn">

          <div className="footer-title">Help & Support</div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Help Center</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Live Chat</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Online Slots</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>FAQ</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Contact Us</NavLink>
                </div>
          </div>
        </IonCol> */}
            {/* <div className="b-text">PEAK GAMING SRL</div>
        <div>San Jose , Costa Rica </div>
        <div className="above-18-years">
          All above <img src={Above18} /> Years
        </div>
        <div className="contact-section">
          {ContactList[BRAND_NAME] ? (
            <>
              <IonImg className="image" src={WhatsupImg} />
              {ContactList[BRAND_NAME]}
            </>
          ) : (
            ''
          )}
        </div>
        */}
            <div className='copyright-text-ctn border_top'>
              Copyrights {new Date().getFullYear()}, {BRAND_NAME} | All rights
              reserved
            </div>
            {
              domainConfig.payments && showDisclaimer ?
                <div className="marquee notifications disclaimer">
                  <div
                    className="info"
                  // onClick={() => setShowNotificationModal(true)}
                  >
                    <img src={DisclaimerImg} />{"  "}Disclaimer
                  </div>
                  <span>Copyrights {new Date().getFullYear()}, {BRAND_NAME} | All rights
                    reserved</span>
                  <div className="close-btn" onClick={() => setShowDisclaimer(false)}>
                    <CloseOutlined />
                  </div>
                </div>
                : null
            }

          </IonRow>
          : null}
      {
        domainConfig.payments ?
          <IonGrid >
            <IonRow class="copyright-ctn border_top web-view">
              <IonCol sizeLg="5" sizeSm="12" sizeXs="12" className='mob-footer-logo-ctn'>
                <img className='footer-logo-web web-view' src={webtitleImg} />
                <img className='footer-logo-mob mob-view' src={webtitleImg} />
                <div className="b-text">PEAK GAMING SRL San Jose ,</div>
                <div> Costa Rica </div>
                {/* <div className="above-18-years">
                  All above <img src={Above18} /> Years
                </div> */}
                <div className="contact-section">
                  {ContactList[BRAND_NAME] ? (
                    <>
                      <IonImg className="image" src={WhatsupImg} />
                      {ContactList[BRAND_NAME]}
                    </>
                  ) : (
                    ''
                  )}
                </div>
                <div className="gamecura">
                  <img src={gamecura} />
                </div>
              </IonCol>
              <IonCol sizeLg="4" sizeSm="12" sizeXs="12">
                <div className="footer-link-ctn">
                  <div className="footer-title">Company</div>
                  <div className="footer-link-div-ctn">
                    <IonRow>
                      <IonCol sizeLg="12" sizeSm="6" sizeXs="6">
                        <div className='footer-link-div'>
                          <div className="footer-link" onClick={() =>
                            setresponsibleDialog({
                              launch: true,
                              name: 'About Us',
                            })}
                          >About Us</div>
                        </div>
                      </IonCol>
                      <IonCol sizeLg="12" sizeSm="6" sizeXs="6">
                        <div className='footer-link-div' >
                          <div className="footer-link"
                          >Rules and Regulations</div>
                        </div>
                      </IonCol>

                      <IonCol sizeLg="12" sizeSm="6" sizeXs="6">
                        <div className='footer-link-div'>
                          <NavLink to={"/sitemap"} className="footer-link">Sitemap</NavLink>
                        </div>
                      </IonCol>

                      <IonCol sizeLg="12" sizeSm="6" sizeXs="6">
                        <div className='footer-link-div'>
                          <div className="footer-link" onClick={() =>
                            setresponsibleDialog({
                              launch: true,
                              name: 'Responsible Gaming',
                            })
                          }>Responsible Gaming</div>
                        </div>
                      </IonCol>
        
                      <IonCol sizeLg="12" sizeSm="6" sizeXs="6">
                        <div className='footer-link-div'>
                          <div className="footer-link" onClick={() =>
                            setresponsibleDialog({
                              launch: true,
                              name: 'Terms and conditions',
                            })}>Terms and conditions</div>
                        </div>
                      </IonCol>
                    </IonRow>
                  </div>
                </div>
              </IonCol>
              <IonCol sizeLg="3" sizeSm="12" sizeXs="12">
                <div className="footer-link-ctn">
                  <div className="footer-social-title">Connect with Us</div>
                  <div className="footer-link-div-ctn">
                    <IonCol className="web-social-media-group">
                      <SocialMedia></SocialMedia>
                    </IonCol>
                  </div>
                </div>
              </IonCol>
              <IonCol sizeLg="12" sizeSm="12" sizeXs="12">
                <div className='disclaimer_new web-view'>
                  <div>
                    Disclaimer:
                  </div>
                  <div>
                    Please note that Gambling involves a financial risk and could be addictive over time if not practised within limits. Only 18+ people should use the services and should use it responsibly. Players should be aware of any financial risk and
                  </div>
                  <div>
                    govern themselves accordingly.
                  </div>
                </div>
                <div className='disclaimer_new mob-view'>
                  <div>
                    Disclaimer:
                  </div>
                  <div>
                    Please note that Gambling involves a financial risk and could be addictive over time if not practised within limits. Only 18+ people should use the services and should use it responsibly. Players should be aware of any financial risk and govern themselves accordingly.
                  </div>
                </div>
              </IonCol>
              <div className='copyright-text-ctn'>
                Copyrights {new Date().getFullYear()}, {BRAND_NAME} | All rights
                reserved
              </div>
            </IonRow>
            <IonRow class="copyright-ctn text_align_left title_image border_top_mob  mob-view">
              <IonCol sizeLg="5" sizeSm="12" sizeXs="12" className='mob-footer-logo-ctn magrin_left_algin pad_top_zero margrin_bot_align'>
                <img className='footer-logo-web web-view' src={webtitleImg} />
                <img className='footer-logo-mob mob-view' src={webtitleImg} />
                <div className="b-text margrin_top_align">PEAK GAMING SRL San Jose ,</div>
                <div> Costa Rica </div>
                {/* <div className="above-18-years">
                  All above <img src={Above18} /> Years
                </div> */}
                <div className="contact-section text_align_left">
                  {ContactList[BRAND_NAME] ? (
                    <>
                      <IonImg className="image" src={WhatsupImg} />
                      {ContactList[BRAND_NAME]}
                    </>
                  ) : (
                    ''
                  )}
                </div>

              </IonCol>
              <IonCol sizeLg="4" sizeSm="12" sizeXs="12" className='border_top_mob magrin_left_algin margrin_bot_align'>
                <div className="footer-link-ctn">
                  <div className="footer-title text_align_left company_title">Company</div>
                  <div className="footer-link-div-ctn">
                    <IonRow>
                      <IonCol sizeLg="12" sizeSm="12" sizeXs="12" className='company_class'>
                        <div className='footer-link-div'>
                          <div className="footer-link text_align_left b-text" onClick={() =>
                            setresponsibleDialog({
                              launch: true,
                              name: 'About Us',
                            })}
                          >About Us</div>
                        </div>
                      </IonCol>
                      <IonCol sizeLg="12" sizeSm="12" sizeXs="12" className='company_class'>
                        <div className='footer-link-div' >
                          <div className="footer-link text_align_left b-text"
                          >Rules and Regulations</div>
                        </div>
                      </IonCol>
                      <IonCol sizeLg="12" sizeSm="12" sizeXs="12" className='company_class'>
                        <div className='footer-link-div'>
                          <NavLink to={"/sitemap"} className="footer-link text_align_left b-text">Sitemap</NavLink>
                        </div>
                      </IonCol>
                      <IonCol sizeLg="12" sizeSm="12" sizeXs="12" className='company_class'>
                        <div className='footer-link-div'>
                          <div className="footer-link text_align_left b-text" onClick={() =>
                            setresponsibleDialog({
                              launch: true,
                              name: 'Responsible Gaming',
                            })
                          }>Responsible Gaming</div>
                        </div>
                      </IonCol>
                      <IonCol sizeLg="12" sizeSm="12" sizeXs="12" className='company_class'>
                        <div className='footer-link-div'>
                          <div className="footer-link text_align_left b-text" onClick={() =>
                            setresponsibleDialog({
                              launch: true,
                              name: 'Terms and conditions',
                            })}>Terms and conditions</div>
                        </div>
                      </IonCol>
                    </IonRow>
                  </div>
                </div>
              </IonCol>
              <IonCol sizeLg="3" sizeSm="12" sizeXs="12" className='border_top_mob magrin_left_algin social_class '>
                <div className="footer-link-ctn">
                  <div className="footer-social-title magrin_left_algin text_align_left company_title">Connect with Us</div>
                  <div className="footer-link-div-ctn ">
                    <IonCol className="web-social-media-group text_align_left pad_zeror">
                      <SocialMedia></SocialMedia>
                    </IonCol>
                  </div>
                </div>
              </IonCol>
              <IonCol sizeLg="12" sizeSm="12" sizeXs="12" className='border_top_mob magrin_left_algin margrin_bot_align'>
                <div className="gamecura">
                  <img src={gamecura} />
                </div>
                <div className='disclaimer_new web-view'>
                  <div>
                    Disclaimer:
                  </div>
                  <div>
                    Please note that Gambling involves a financial risk and could be addictive over time if not practised within limits. Only 18+ people should use the services and should use it responsibly. Players should be aware of any financial risk and
                  </div>
                  <div>
                    govern themselves accordingly.
                  </div>
                </div>
                <div className='disclaimer_new mob-view'>
                  <div>
                    Disclaimer:
                  </div>
                  <div>
                    Please note that Gambling involves a financial risk and could be addictive over time if not practised within limits. Only 18+ people should use the services and should use it responsibly. Players should be aware of any financial risk and govern themselves accordingly.
                  </div>
                </div>
              </IonCol>
              <div className='copyright-text-ctn text_align_left border_top_mob magrin_left_algin'>
                Copyrights {new Date().getFullYear()}, {BRAND_NAME} | All rights
                reserved
              </div>
            </IonRow>
            <Drawer
              anchor={'right'}
              open={responsibleDilalog.launch}
              onClose={() =>
                setresponsibleDialog({
                  launch: false,
                  name: null,
                })
              }
              className="light-bg-title game-rules-drawer web-view"
              title="Rules"
            // size="md"
            >
              <div className="game-rules-header">
                <div className="game-rules-title">{responsibleDilalog.name}</div>
                <div className="game-rules-close cursor" onClick={() => setresponsibleDialog({
                  launch: false,
                  name: null,
                })}><CloseOutlined /></div>
              </div>
              <ResponsibleGaming
                name={responsibleDilalog.name}
                eventTypeID={responsibleDilalog.name}
              />
            </Drawer>
            <Drawer
              anchor={'bottom'}
              open={responsibleDilalog.launch}
              onClose={() =>
                setresponsibleDialog({
                  launch: false,
                  name: null,
                })
              }
              className="light-bg-title game-rules-drawer mob-view"
              title="Rules"
            // size="md"
            >
              <div className="game-rules-header">
                <div className="game-rules-title">{responsibleDilalog.name}</div>
                <div className="game-rules-close cursor" onClick={() => setresponsibleDialog({
                  launch: false,
                  name: null,
                })}><CloseOutlined /></div>
              </div>
              <ResponsibleGaming
                name={responsibleDilalog.name}
                eventTypeID={responsibleDilalog.name}
              />
            </Drawer>
          </IonGrid>
          : null}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    eventTypes: state.exchangeSports.eventTypes,
    allowedConfig: state.common.allowedConfig,
    domainConfig: state.common.domainConfig
  };
};

export default connect(mapStateToProps)(Copyright);
